import { render, staticRenderFns } from "./EmptyResults.vue?vue&type=template&id=454e26a6&scoped=true&"
import script from "./EmptyResults.vue?vue&type=script&lang=js&"
export * from "./EmptyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e26a6",
  null
  
)

export default component.exports